export function getFirstCapabilityValue(
  capabilities:
    | ({ capabilityType: string | null | undefined; values: string[] } | null | undefined)[]
    | null
    | undefined,
  capabilityType: string
) {
  const matchingValues =
    capabilities?.find(item => item?.capabilityType === capabilityType)?.values ?? [];
  return matchingValues.find(() => true);
}
